import React, { memo } from 'react';
import { Text, TouchableOpacity, View } from "react-native";
const FilterChip = ({ title, noOfItems, selected = false, action, triggerAction }) => {
    const onClick = () => {
        action && triggerAction(action);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(TouchableOpacity, { onPress: onClick },
            React.createElement(View, { style: {
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    paddingLeft: 5,
                    paddingRight: 16,
                    paddingTop: 5,
                    paddingBottom: 5,
                    backgroundColor: selected ? '#E7EBFA' : '#F1F3F5',
                    borderRadius: 16
                } },
                React.createElement(View, { style: {
                        borderRadius: 32,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        paddingTop: 2,
                        paddingBottom: 2,
                        paddingLeft: 8,
                        paddingRight: 8,
                        marginRight: 8,
                        backgroundColor: selected ? '#D0D6F5' : '#E4E7EC',
                    } },
                    React.createElement(Text, { style: {
                            fontFamily: 'Inter',
                            fontSize: 12,
                            fontWeight: '500',
                            lineHeight: 18,
                            color: selected ? '#1434CB' : '#667085'
                        } }, noOfItems ? noOfItems : '00')),
                React.createElement(View, null,
                    React.createElement(Text, { style: {
                            fontFamily: 'Inter',
                            fontSize: 14,
                            fontWeight: '500',
                            lineHeight: 20,
                            color: selected ? '#1434CB' : '#667085'
                        } }, title))))));
};
export default memo(FilterChip);
export { FilterChip };
